<template>
  <SvgoDrAlexisGranite class="h-auto w-40 lg:w-50" :font-controlled="false" />
</template>
